import React, { useState, useEffect } from 'react';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "";

// Берем гостевой домен из переменных сборки
const GUEST_DOMAIN = import.meta.env.VITE_GUEST_URL || "https://join.sharecoop.icloud.ec";

export const RecordingsPage: React.FC = () => {
	const [recordings, setRecordings] = useState<any[]>([]);
	const [filterDate, setFilterDate] = useState("");
	const [sortOrder, setSortOrder] = useState("desc");
	
	// Добавляем состояние для Тоста
	const [toastMessage, setToastMessage] = useState<string | null>(null);

	useEffect(() => {
		fetch(`${BACKEND_URL}/api/recordings`)
			.then(res => res.json())
			.then(data => setRecordings(data))
			.catch(err => console.error(err));
	}, []);

	const filteredAndSorted = recordings.filter(rec => {
		if (!filterDate) return true;
		const recDate = new Date(rec.date).toISOString().split('T')[0];
		return recDate === filterDate;
	}).sort((a, b) => {
		const timeA = new Date(a.date).getTime();
		const timeB = new Date(b.date).getTime();
		return sortOrder === "desc" ? timeB - timeA : timeA - timeB;
	});

	const handleCopyLink = (filename: string, isoDate: string) => {
		// Добавлен /record для правильной ссылки на плеер
		const link = `${GUEST_DOMAIN}/record?v=${filename}&date=${encodeURIComponent(isoDate)}`;
		navigator.clipboard.writeText(link).then(() => {
			// Показываем Тост вместо alert
			setToastMessage("Ссылка скопирована!");
			setTimeout(() => setToastMessage(null), 2000);
		}).catch(err => console.error("Ошибка копирования: ", err));
	};

	return (
		<div style={{ 
			position: 'absolute', 
			top: 0, left: 0, right: 0, bottom: 0, 
			overflowY: 'auto', 
			background: 'transparent', 
			color: 'white', 
			boxSizing: 'border-box', // Не дает паддингам растянуть блок больше 100% экрана
			padding: '80px 20px 40px', // Отступ: 80px сверху (сдвигает заголовок вниз), 20px по бокам, 40px снизу
			fontFamily: 'sans-serif'
		}}>
			<div style={{ maxWidth: '900px', margin: '0 auto' }}>
				
				{/* ШАПКА И ФИЛЬТРЫ */}
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', flexWrap: 'wrap', gap: '15px' }}>
					<h1 style={{ margin: 0 }}>Архив записей</h1>
					
					<div style={{ display: 'flex', gap: '15px' }}>
						<input type="date" value={filterDate} onChange={(e) => setFilterDate(e.target.value)} style={{ padding: '10px', borderRadius: '8px', border: '1px solid #333', background: '#1e1e1e', color: 'white', colorScheme: 'dark' }} />
						<select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} style={{ padding: '10px', borderRadius: '8px', border: '1px solid #333', background: '#1e1e1e', color: 'white' }}>
							<option value="desc">Сначала новые</option>
							<option value="asc">Сначала старые</option>
						</select>
						<a href="/" style={{ padding: '10px 20px', background: '#333', color: 'white', textDecoration: 'none', borderRadius: '8px', fontWeight: 'bold' }}>Назад</a>
					</div>
				</div>

				{/* СПИСОК ЗАПИСЕЙ */}
				<div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
					{filteredAndSorted.length === 0 ? <p style={{ color: '#888' }}>Записей не найдено.</p> : null}

					{filteredAndSorted.map((rec: any) => {
					const isoDate = new Date(rec.date).toISOString();
					
					// ❗️ Жестко задаем локаль для формата дд.мм.гггг
					const displayDate = new Date(rec.date).toLocaleDateString('ru-RU');
					// ❗️ Сюда тоже можно добавить, чтобы время точно было 24-часовым (без AM/PM)
					const displayTime = new Date(rec.date).toLocaleTimeString('ru-RU', {hour: '2-digit', minute:'2-digit'});
					
					return (
							<div key={rec.filename} style={{ background: '#1e1e1e', borderRadius: '12px', border: '1px solid #333', display: 'flex', padding: '15px', gap: '20px', alignItems: 'center' }}>
								
								{/* ПРЕВЬЮ (Слева) */}
								<div style={{ width: '160px', height: '90px', background: 'black', borderRadius: '8px', overflow: 'hidden', flexShrink: 0, pointerEvents: 'none' }}>
									<video src={`${BACKEND_URL}/recordings/${rec.filename}`} preload="metadata" muted style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
								</div>
								
								{/* ИНФОРМАЦИЯ (По центру) */}
								<div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
									<h3 style={{ margin: '0 0 5px 0', fontSize: '18px' }}>Запись от {displayDate}</h3>
									<div style={{ color: '#888', fontSize: '14px' }}>
										Время: {displayTime} • Размер: {(rec.sizeBytes / 1024 / 1024).toFixed(1)} MB
									</div>
								</div>
								
								{/* КНОПКИ (Справа) */}
								<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flexShrink: 0, width: '180px' }}>
									<button 
										onClick={() => window.open(`${GUEST_DOMAIN}/record?v=${rec.filename}&date=${encodeURIComponent(isoDate)}`, '_blank')}
										style={{ textAlign: 'center', background: '#0fb165', color: 'white', border: 'none', padding: '10px', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', display: 'block', cursor: 'pointer' }}
									>
										Посмотреть
									</button>
									<button 
										onClick={() => handleCopyLink(rec.filename, isoDate)}
										style={{ background: '#333', color: 'white', border: '1px solid #555', padding: '10px', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}
									>
										Поделиться
									</button>
								</div>
							</div>
						);
					})}
				</div>
			</div>

			{/* ВСПЛЫВАЮЩИЙ TOAST (Вместо alert) */}
			{toastMessage && (
				<div style={{
					position: 'fixed', bottom: '40px', left: '50%', transform: 'translateX(-50%)',
					backgroundColor: '#0fb165', color: 'white', padding: '12px 24px',
					borderRadius: '8px', fontWeight: 'bold', boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
					zIndex: 1000, animation: 'fadeInOut 2s ease-in-out'
				}}>
					{toastMessage}
				</div>
			)}
		</div>
	);
};